<template>
  <div class="flex-1 flex flex-col bg-background">
    <Head title="Kiosk" />

    <div class="flex-1 flex items-center justify-center px-4 py-8">
      <h1 class="text-4xl md:text-6xl font-bold text-foreground">
        KIOSK
      </h1>
    </div>
  </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3'

import Layout from '@/Layouts/Bare.vue'

// Define layout for Inertia
defineOptions({
  layout: Layout
})
</script>
